import styled from "styled-components";

export const Container123 = styled.header`
  width: 100%;
  height: 10%;
  background: white;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  div {
    padding: 1%;
    img {
      width: 150px;
      height: auto;
      cursor: pointer;
    }

    span {
      color: #e71037;
      font-weight: 800;
      font-size: 0.7rem;
    }
  }
`;
